import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from "@angular/core";
import { Action } from "@app/models";
import { TranslateService } from "@ngx-translate/core";
import { Observable, switchMap } from "rxjs";
import { ActionListItemService } from "../../services/action-list-item.service";

@Component({
  selector: "action-rating-information",
  template: `
    <div class="display-flex-start">
      <span [innerHTML]="text | async" class=""></span>&nbsp;
      <contact-summary [contactId]="item.contactId"></contact-summary>
    </div>
  `,
  styleUrls: ["./common.scss"],
})
export class ActionRatingInformationComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() item: Action;

  text: Observable<string>;
  listenerName: Function;
  listenerObject: Function;

  className = "action-rating-information-name";

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private translateService: TranslateService,
    public itemService: ActionListItemService
  ) {}

  ngOnInit() {
    this.text = this.itemService.getYouTranslation(this.item).pipe(
      switchMap((youString: string) =>
        this.translateService.get("action_rating_information_text", {
          you: youString,
          name: `<span class="${this.className} text-link">${this.item.firstName} ${this.item.familyName}</span>`,
          stars: this.getStarString(this.item.param1),
        })
      )
    );
  }

  ngAfterViewInit() {
    this.listenerName = this.itemService.createContactLinkListener(
      this.elementRef,
      this.renderer,
      this.className,
      this.item.contactId
    );
    this.listenerObject = this.itemService.createObjectLinkListener(
      this.elementRef,
      this.renderer,
      this.className,
      this.item.contactId
    );
  }

  ngOnDestroy() {
    const listeners = [this.listenerObject, this.listenerName];
    listeners.forEach((listener: Function) => {
      if (listener) {
        listener();
      }
    });
  }

  getStarString(stars: string): string {
    let starsString = "";
    const rating = parseInt(stars, 0);
    for (let i = 0; i < rating; i++) {
      starsString += '<i class="fa fa-star star"></i>';
    }
    for (let i = 0; i < 3 - rating; i++) {
      starsString += '<i class="fa fa-star-o star"></i>';
    }
    return starsString;
  }
}
